<template>
  <div class="team-table">
    <div class="col-12">
      <h1>Csapatok</h1>
    </div>

    <div class="col-12">
      <div class="display-small-only">
        <div>
          <p>Ki nyeri a döntőt?</p>
              <button @click="sendFirstWinner()"
                      class="btn btn-bet m-auto"
                      v-if="showBtnsBeforeFirstMatch"
              >
              <span v-if="!hasFirstWinner">Fogadás</span>
              <span v-else>Fogadás módosítása</span>
              </button>
            <div  class="error" v-else>Már nem fogadhatsz</div>
        </div>
        
        <div class="padding-plus-mobile">
          <p>Kik kerülnek a legjobb 4 közé?</p>
            <button @click="checkFourWinnerPost()"
                    class="btn btn-bet center m-auto"
                    v-if="showBtnsBeforeFirstMatch"
            >
                    <span v-if="!hasFourWinner">Fogadás</span>
                    <span v-else>Fogadás módosítása</span>
            </button>
            <div class="error"  v-if="!showBtnsBeforeFirstMatch">Már nem fogadhatsz</div>
        </div>
      </div>
    </div>
    
    <div class="col-12">
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">Ország</th>
            <th scope="col">Csoport</th>
            <th scope="col">Informació</th>
            <th scope="col">Ki nyeri a döntőt?
              <button @click="sendFirstWinner()"
                      class="btn btn-bet m-auto"
                      v-if="showBtnsBeforeFirstMatch">
                <span v-if="!hasFirstWinner">Fogadás</span>
                <span v-else>Fogadás módosítása</span>
              </button>
              <div  class="error" v-else>Már nem fogadhatsz</div>
            </th>
            <th scope="col" class="column">Kik kerülnek a legjobb 4 közé?
              <button @click="checkFourWinnerPost()"
                      class="btn btn-bet center m-auto"
                      v-if="showBtnsBeforeFirstMatch">
                      <span v-if="!hasFourWinner">Fogadás</span>
                      <span v-else>Fogadás módosítása</span>
              </button>
              <div class="error"  v-if="!showBtnsBeforeFirstMatch">Már nem fogadhatsz</div>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="team in teams" :key="team.id">
            <td>{{ team.country }}</td>
            <td>{{ team.group }}</td>
            <td>
              <div class="text-overflow-elipsys"><a :href=team.link target="_blank">{{ team.link }}</a></div>
            </td>
            <td>
              <b-form-radio 
                v-model="firsWinner" 
                name="some-radios" 
                :value="team.id"
              >
              </b-form-radio>
            </td>

            <td>       
              <b-form-checkbox 
                v-model="checkedTeams"               
                :value="team.id"
                :disabled="!inCheckedTeams(team.id) && checkedTeams.length === 4"
              />           
            </td>
          </tr>
        </tbody>

      </table>
    </div>

    <!-- MODAL -->
    <b-modal id="msg-modal" hide-footer @hidden="resetModal()">
      <template #modal-title>
        {{modalTitle}}
      </template>
      <div class="d-block text-center">
        {{modalText}}
      </div>
      <b-button class="mt-3" block @click="resetModal()">Ok</b-button>
    </b-modal>
  </div>
</template>

<script>
// import ApiHandler from "@/mixins/apiHandlerMI"
import viewMI from "@/mixins/viewMI";

export default {
  props:['firstMatchTime'],
  data() {
    return {
      checkedTeams: [],           
      successMessage: false,
      firsWinner:null,
      theWinner: [],
      modalText: '', 
      modalTitle: '',
      showModal : false, 
      isFirstMatchStarted: false, 
      showBtnsBeforeFirstMatch: true,
      hasFirstWinner: false,
      hasFourWinner:false
    }
  },
  mixins: [viewMI],
  watch:{
    showModal(){
      if (this.showModal === true){
        this.$bvModal.show('msg-modal')
      } else {
        this.$bvModal.hide('msg-modal')
      }      
    },
    currentTime(){        
      //globalMI data
        let _this = this
          if (_this.getCurrentServerTime){
            _this.getCurrentServerTime()
          }
      },
  },
  computed: {   
    teams() {
      return this.$store.state.team;
    },          
  },     

  methods: {
    userReady(){        
    
      this.getWinnerTeam(); 
      this.getFirstWinner()
      this.currentServerTime()     //start to get the current Server time         
 
    },
    getCurrentServerTime(){
      let _this = this      

      let currentTime = this.moment(_this.currentTime)
           
      // console.log('isBefore', _this.firstMatchTime, _this.moment(_this.firstMatchTime).isBefore(currentTime))   
      
      // hide the buttons
      if ( _this.moment(_this.firstMatchTime).isBefore(currentTime)){
        _this.showBtnsBeforeFirstMatch = false
      }

    },
    getWinnerTeam() {
      let _this = this
      let userId = this.$store.state.user.id
      // console.log('userid', userId)

      _this.get('chosen_first_four_team', 
          {
            params: {
              where: [['where', 'user_id', userId ]]
            }
          },
          function (response) {
            // console.log('chosen_first_four_team', response.data)    
            if (response.data.status === true){        
              let FourWinners = response.data.chosen_first_four_team[0]            
              _this.checkedTeams.push(FourWinners.team1_id)
              _this.checkedTeams.push(FourWinners.team2_id)
              _this.checkedTeams.push(FourWinners.team3_id)
              _this.checkedTeams.push(FourWinners.team4_id)
              _this.hasFourWinner = true
            }else {
              _this.checkedTeams = []
            }

          }, function (error) {
            //error
            console.log('error', error)

            // if (error.data.error == 'Not found!') {
            //   _this.error = 'Something went wrong :('
            // }
            _this.checkedTeams = []
          }
      )
    },
    getFirstWinner() {
      const _this = this;

      this.get('chosen_winner', {
            params: {
              where: [['where', 'user_id', this.$store.state.user.id]]
            }
          },
          function (response) {
            // console.log(response.data)
            if (response.data.status === true){
              _this.firsWinner = response.data.chosen_winner[0].team_id
              _this.hasFirstWinner = true
            } else{
              _this.firsWinner = null
              _this.hasFirstWinner = false
            }

          }, function (error) {
            //error
            console.log('error getFirstWinner', error)
            _this.firsWinner = null
           
          }
      )
    },
    
    sendFirstWinner() {
        console.log('sendFirstWinner')
        let _this = this;
        _this.post('chosen_winner_send',
            {
              user_id: this.$store.state.user.id,
              team_id: _this.firsWinner
            },
            {}, function (response) {
              //success
              console.log(response.data)
              if (response.data.status === true){
                _this.modalText = 'Köszönjük, az első helyezett csapatra leadtad a fogadásod'
                _this.showModal = true
                _this.modalTitle = 'Fogadás leadása'
              }

            }, function (error) {
              //error
              console.log('postWinnerTeam error:', error.data)
              _this.modalText = 'Valami hiba történt, kérjük próbáld újra'
              _this.showModal = true
              _this.modalTitle = 'Figyelem!'
              
            }
        )
      
    },
    checkFourWinnerPost(){
      let _this = this

      //!figyelni kell post előtt hogy elkezdődött e közben a meccs
      if (this.checkedTeams.length !== 4){
        _this.modalTitle = 'Figyelem!'
        _this.modalText = 'Minimum 4 csapat jelölése szükséges a fogadáshoz'
        _this.showModal = true
      } else {
        _this.postFirstFourWinnerTeam()
      }
    },
    postFirstFourWinnerTeam() {
      let _this = this;

      _this.post('chosen_first_four_team_send',
          {
            user_id: this.$store.state.user.id,
            team1_id: _this.checkedTeams[0],
            team2_id: _this.checkedTeams[1],
            team3_id: _this.checkedTeams[2],
            team4_id: _this.checkedTeams[3]
          },
          {}, function (response) {
            //success
            console.log('Sikeres beküldés', response.data)
            if (response.data.status === true){
              // alert ('Sikeres beküldés')
              _this.modalText = 'Köszönjük, fogadásod sikeresen leadtad'
              _this.showModal = true
              _this.modalTitle = 'Fogadás leadása'
            }            
          }, function (error) {
            //error
            console.log('postFirstFourWinnerTeam error:', error.data)

            _this.modalText = 'Valami hiba történt, kérjük próbáld újra'
            _this.showModal = true
            _this.modalTitle = 'Figyelem!'
          }
      )
    },
    inCheckedTeams(teamId){
      return this.checkedTeams.find( team => team === teamId)
    },
    resetModal(){
      this.showModal = false
      this.modalText = ''
      this.modalTitle = ''
    }
  }
}
</script>

<style scoped>

</style>